// extracted by mini-css-extract-plugin
export var bounce = "MenuFooter-module--bounce--b5fca";
export var dotMoveLeft = "MenuFooter-module--dot-move-left--df20c";
export var dotMoveRight = "MenuFooter-module--dot-move-right--8ed6c";
export var gradient = "MenuFooter-module--gradient--59621";
export var item = "MenuFooter-module--item--e84f5";
export var menu = "MenuFooter-module--menu--c9907";
export var separatorWidth = "MenuFooter-module--separator-width--f0cfc";